import { classNames } from 'tradera/utils/class-names';
import React from 'react';

import styles from './separator.module.scss';

type SeparatorProps = { className?: string; thick?: boolean };

export const VerticalSeparator = ({
    className,
    thick = false
}: SeparatorProps) => (
    <span
        className={classNames(
            styles.separatorVertical,
            thick && styles.separatorVerticalWide,
            className
        )}
    />
);

export const HorizontalSeparator = ({
    className,
    thick = false
}: SeparatorProps) => (
    <hr
        className={classNames(
            styles.separatorHorizontal,
            thick && styles.separatorHorizontalThick,
            className
        )}
    />
);
